import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ShopManagementSoftware.css";

export default function ShopManagementSoftware() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: true });
  }, []);

  const features = [
    { icon: "🛒", title: "POS Billing System" },
    { icon: "📦", title: "Inventory Management" },
    { icon: "📊", title: "Sales Analytics" },
    { icon: "🏬", title: "Multi-Store Support" },
    { icon: "🧾", title: "Invoice Generation" },
    { icon: "🔐", title: "User Roles & Security" },
  ];

  const benefits = [
    { icon: "⚡", title: "Faster Billing Process" },
    { icon: "💰", title: "Increase Profitability" },
    { icon: "📉", title: "Reduce Stock Loss" },
    { icon: "📈", title: "Business Growth Insights" },
  ];

  const industries = [
    "Retail Stores",
    "Supermarkets",
    "Pharmacies",
    "Garments Shops",
    "Electronics Shops",
    "Wholesale Dealers",
  ];

  const faqs = [
    {
      q: "What is shop management software?",
      a: "It is a complete system that manages billing, inventory, sales and customers for retail businesses.",
    },
    {
      q: "Does it include POS system?",
      a: "Yes, it includes a fully integrated POS billing system.",
    },
  ];

  return (
    <div className="shop-page">
      {/* HERO */}
      <section className="hero text-center" data-aos="fade-up">
        <h1>
          Shop Management <span>Software</span>
        </h1>
        <p className="hero-text">
          Smart <b>ERP, POS & Inventory Management System</b> for retail stores,
          supermarkets, pharmacies and modern businesses to manage sales,
          billing, stock and customers in one place.
        </p>
      </section>

      {/* INTRODUCTION */}
      <section className="intro" data-aos="fade-up">
        <p className="gradient-text">
          A powerful shop management system designed to simplify retail
          operations, automate billing, and provide real-time inventory control.
          Built for scalability, speed, and accuracy.
        </p>
      </section>

      {/* FEATURES */}
      <section className="section">
        <h2 data-aos="fade-up">Features</h2>

        <div className="grid">
          {features.map((f, i) => (
            <div className="card" key={i} data-aos="zoom-in">
              <div className="icon">{f.icon}</div>
              <h3>{f.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* BENEFITS */}
      <section className="section">
        <h2 data-aos="fade-up">Benefits</h2>

        <div className="grid">
          {benefits.map((b, i) => (
            <div className="card" key={i} data-aos="fade-up">
              <div className="icon">{b.icon}</div>
              <h3>{b.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="section">
        <h2 data-aos="fade-up">Industries</h2>

        <div className="industry-grid">
          {industries.map((item, i) => (
            <div className="industry-box" key={i} data-aos="zoom-in">
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <h2 data-aos="fade-up">FAQs</h2>

        <div className="faq">
          {faqs.map((f, i) => (
            <div className="faq-item" key={i} data-aos="fade-up">
              <h4>{f.q}</h4>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta" data-aos="zoom-in">
        <h2>Ready to Upgrade Your Shop System?</h2>
        <p>Get a powerful ERP + POS solution for your retail business today.</p>
        <a href="/contact" className="btn">
          Get Free Consultation
        </a>
      </section>
    </div>
  );
}
